var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitivos2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5e7076;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.99,178.6c-17.83,0-34.82-10.41-47.84-29.32-12.24-17.77-19.26-40.93-19.26-63.54V44.26l3.8,.48c8.48,1.06,21.56,1.11,35.72-4.71,9.47-3.9,18.14-9.96,25.08-17.53l2.49-2.72,2.5,2.71c6.97,7.58,15.65,13.64,25.09,17.53,14.16,5.82,27.25,5.77,35.73,4.71l3.8-.48v41.48c0,22.61-7.02,45.77-19.27,63.54-13.02,18.91-30.02,29.32-47.85,29.32ZM39.66,51.83v33.91c0,45.06,28.76,86.1,60.33,86.1s60.35-41.04,60.35-86.1V51.83c-9.17,.69-21.81,.01-35.34-5.55-9.25-3.81-17.83-9.52-25-16.62-7.15,7.09-15.72,12.8-25,16.62-13.54,5.56-26.16,6.24-35.33,5.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitivos2);
export default __webpack_public_path__ + "static/media/competitivos2.ccee82acf824b4597143b54526ee2b2a.svg";
export { ForwardRef as ReactComponent };